<template>
  <div :class="classes">
    <pt-page-title title="积分任务详情"></pt-page-title>
    <div v-if="currentData">
      <pt-sub-title title="任务详情"></pt-sub-title>
      <pt-form-item class="special" label="任务名称：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentData.content}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="说明文字：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentData.description}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="单次积分：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentData.unitAndValue}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="上限：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentData.limitTypeCopy}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="上限次数：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentData.limitTimesCopy}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="发布时间：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentData.createdDateCopy}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="变更记录：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <edit-logs :pointsTaskId="$route.params.id"></edit-logs>
      </pt-form-item>
    </div>
    <div class="marginTop">
      <el-button type="primary" @click="goEdit(currentData)">编辑</el-button>
    </div>
  </div>
</template>

<script>
import editLogs from './edit-logs'
// 组件class前缀
const prefixCls = 'pt-integral-task-detail'

export default {
  name: 'pt-integral-task-detail',
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          base: {}
        }
      }
    }
  },
  components: { editLogs },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  watch: {
    data (val) {
      this.currentData = val
    }
  },
  data () {
    return {
      labelWidth: '150px',
      lineHeight: '26',
      currentData: this.data
    }
  },
  methods: {
    goEdit (data) {
      this.$router.push(`/integral-task-form/true/${data.id}`)
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import '~less/var.less';

/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-integral-task-detail{
  .special >span{
    color:@mainColor;
  }
  .quaImages{
    width:204px;
    height: 128px;
  }
  .pictureNames{
    display: flex;
    margin:0;
    padding-left: 0;
    li{
      width:204px;
      line-height: 20px;
      text-align: center;
    }
  }
}
</style>
